import styled from "styled-components";

const STPageHeader = styled.h1`
  font-size: 18px;
  margin: 0;
  margin-bottom: 16px;
  width: fit-content;
`;

export default STPageHeader;
